exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.forTable {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n.forInput {\n  float: right;\n}\n", ""]);

// exports
